import React from "react";

export const Crypto15minIcon = ( props: React.SVGProps<SVGSVGElement> ) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
        fill="none"
        {...props}
    >
        <g clipPath="url(#clip0_17454_52613)">
            <path
                d="M2.3335 1.33203H13.6668"
                stroke="#77808D"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M2.3335 14.668H13.6668"
                stroke="#77808D"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M3.66699 14.6667C4.55589 10.2204 6.00033 7.99813 8.00033 8C10.0003 8.00187 11.4448 10.2241 12.3337 14.6667H3.66699Z"
                stroke="#77808D"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M12.3337 1.33203C11.4448 5.77833 10.0003 8.00056 8.00033 7.9987C6.00033 7.99683 4.55589 5.77463 3.66699 1.33203H12.3337Z"
                stroke="#77808D"
                strokeWidth="1.5"
                strokeLinejoin="round"
            />
            <path
                d="M7 5H9"
                stroke="#77808D"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M6.3335 12.668H9.66683"
                stroke="#77808D"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </g>
        <defs>
            <clipPath id="clip0_17454_52613">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);
